import { IconSize } from 'constants/coreDesignSystem';

export const DTMF_KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'];

export const CALL_CONTROL_ICON_SIZE = IconSize[24];

export const PRIMARY_ACTION_ICON_SIZE = IconSize[32];

export const ONE_SECOND_MS = 1000;

export const SECONDS_PER_MINUTE = 60;

export const HOLD_DEBOUNCE_MS = 250;

export const CALL_STATE_LABEL = {
  CONNECTING: 'Connecting…',
  RINGING: 'Ringing…',
  INCOMING: 'Incoming call…',
  IN_CALL: 'In call',
  ON_HOLD: 'On hold',
};

export const DISPOSITION_OPTIONS = [
  { value: 'CONNECTED', name: 'Connected' },
  { value: 'BUSY', name: 'Busy' },
  { value: 'LIVE_MESSAGE', name: 'Left live message' },
  { value: 'VOICEMAIL', name: 'Left voicemail' },
  { value: 'NO_ANSWER', name: 'No answer' },
  { value: 'WRONG_NUMBER', name: 'Wrong number' },
  { value: 'HANG_UP', name: 'Hung up' },
  { value: 'INVALID_NUMBER', name: 'Invalid number' },
];

export const DISPOSITION_FIELD_NAME = 'disposition';

export const NOTE_FIELD_NAME = 'note';
